// extracted by mini-css-extract-plugin
export default {"previewTable":"ReportConsolidadoPreview_previewTable__XZfMy"};